import { StockPlansGet200ResponseRowsInnerStatusEnum } from "@sizlcorp/sizl-api-document/dist/models";
import { t } from "i18next";

type StatusObjType = {
  [key: string]: string;
};

// 수발주 상태
export const purchaseOrderStatusColor = {
  DRAFT: "dark.1",
  IN_PROGRESS: "indigo.6",
  DONE: "teal.9",
  CANCELED: "orange.4",
};

export const purchaseOrderStatus: StatusObjType = {
  DRAFT: t("purchaseStatus.DRAFT"),
  IN_PROGRESS: t("purchaseStatus.IN_PROGRESS"),
  DONE: t("purchaseStatus.DONE"),
  CANCELED: t("purchaseStatus.CANCELED"),
};

export const setPurchaseOrderStatus = (status: string) => {
  return purchaseOrderStatus[status];
};

// 수발주 항목 상태

export const purchaseOrderItemStatusColor = {
  DRAFT: "dark.1",
  PARTIAL_DELIVERED: "indigo.6",
  DELIVERED: "teal.9",
  CANCELED: "orange.4",
};

export const purchaseOrderItemStatus: StatusObjType = {
  DRAFT: t("purchaseOrderItemsStatus.DRAFT"),
  PARTIAL_DELIVERED: t("purchaseOrderItemsStatus.PARTIAL_DELIVERED"),
  DELIVERED: t("purchaseOrderItemsStatus.DELIVERED"),
  CANCELED: t("purchaseOrderItemsStatus.CANCELED"),
};

export const setPurchaseOrderItemStatus = (status: string) => {
  return purchaseOrderItemStatus[status];
};

// 배차 상태
export const transportationStatusColor = {
  SCHEDULED: "indigo.6",
  LOADING: "orange.4",
  DONE: "teal.9",
  ON_ROAD: "green.7",
  ERROR: "red.6",
};

export const transportationStatus: StatusObjType = {
  SCHEDULED: t("transportationStatus.SCHEDULED"),
  LOADING: t("transportationStatus.LOADING"),
  DONE: t("transportationStatus.DONE"),
  ON_ROAD: t("transportationStatus.ON_ROAD"),
  ERROR: t("transportationStatus.ERROR"),
};

export const setTransportationStatus = (status: string) => {
  return t(transportationStatus[status]);
};

interface StockPlanType {
  label: StockPlansGet200ResponseRowsInnerStatusEnum;
  value: StockPlansGet200ResponseRowsInnerStatusEnum;
}

export const StockPlanType: StockPlanType[] = [
  { label: "PLANNED", value: "PLANNED" },
  { label: "DONE", value: "DONE" },
  { label: "CANCELED", value: "CANCELED" },
];

// 재고계획 상태
export const stockPlanStatusColor = {
  PLANNED: "blue.7",
  DONE: "teal.9",
  CANCELED: "orange.4",
};

export const stockPlanStatus: StatusObjType = {
  PLANNED: t("stockPlanStatus.PLANNED"),
  DONE: t("stockPlanStatus.DONE"),
  CANCELED: t("stockPlanStatus.CANCELED"),
};

export const setStockPlanStatus = (status: string) => {
  return stockPlanStatus[status];
};
